<template>
  <v-autocomplete
    required
    :multiple="multiple"
    :rules="rules"
    :items="list"
    v-model="select"
    @change="_fnChange"
    :readonly="readonly"
    :clearable="!readonly && !rules"
  >
    <template #label>
      {{ $t(`table.ward`) }}
      <span class="red--text" v-if="rules">
        <strong>*</strong>
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: "selected",
    event: "change",
  },
  props: {
    selected: [String, Array],
    district: String,
    rules: Array,
    multiple: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      select: "",
      list: [],
    };
  },
  watch: {
    district: function () {
      this.select = "";
      this.$emit("change", this.select);
      this._fnInit();
    },
  },
  created() {
    this._fnInit();
  },
  methods: {
    _fnInit() {
      this.Ward.filter.limit = 1000;
      this.Ward.filter.district = this.district;
      this.fnGets({
        url: "/v1/admin/ward",
        model: "Ward",
      }).then(({ data }) => {
        this.Ward.list = [];
        data.forEach((e) => {
          e.text = e.name;
          e.value = e.id;
        });
        this.list = data;
        this.select = this.selected || "";
      });
    },
    _fnChange() {
      this.$emit("change", this.select);
    },
  },
};
</script>
